module.exports = __webpack_public_path__ + "static/explainer1-alt-a18cd58dc2106fd4d30f5f7154c722a5.png";